export default __webpack_public_path__ + "static/media/32.6c12e639.png";